import {EinsteinDatabase} from "./EinsteinDatabase";

export let db = new EinsteinDatabase();


// WEBPACK FOOTER //
// ./src/storage/db.ts